// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__lE0h1","title":"Images90_title__1NyUr","images":"Images90_images__2XeON"};